

























































































































import { Component, Vue } from "vue-property-decorator";

export default Vue.extend({
    data(){
      return {
          wpData: ""
      }
    },
    components: {},
    methods: {
        async getData(){
            await fetch(this.$store.state.URL+'pages?include=8,10,12')
            .then((r) => r.json())
            .then((res) => {
              this.wpData = res;
              });
            },
        trackButtonClick () {
            this.$gtag.event('Klick på knapp', {
                'event_category': 'CTA-knapp',
                'event_label': 'Läs mer - Tjänster',
                'value': 'Startsidan'
            })
        },
        trackImagelick (clickedImg: any) {
            this.$gtag.event('Klick på bild', {
                'event_category': 'Bild',
                'event_label': 'Klick på ' + clickedImg,
                'value': clickedImg
            })
        }
    },
    mounted(){
        this.getData()
    }
})
